import type { MouseEventHandler } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import type { IButtonProps } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";

import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

type Props = {
    isSignalsListEmpty?: boolean;
    onClick: MouseEventHandler<HTMLButtonElement>;
    emptyListBtnText?: string;
    fillListBtnText?: string;
    height?: IButtonProps["height"];
    iconSize?: string;
};

const SignalsManagementButton = ({
    isSignalsListEmpty,
    onClick,
    emptyListBtnText = signalsI18nKeys.manageSignals.firstSignalCta,
    fillListBtnText = signalsI18nKeys.manageSignals.cta,
    height,
    iconSize = "16px",
}: Props) => {
    const { translate } = useTranslate();

    return (
        <IconButton
            dataAutomation="signals-management-button"
            iconName={isSignalsListEmpty ? "add" : "settings"}
            iconColor={colorsPalettes.blue[400]}
            iconSize={iconSize}
            type="flat"
            height={height}
            onClick={onClick}
        >
            {translate(isSignalsListEmpty ? emptyListBtnText : fillListBtnText)}
        </IconButton>
    );
};

export default SignalsManagementButton;
